import React from 'react';
import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaStar, FaShoppingCart } from 'react-icons/fa';
import { useCart } from '../context/CartContext';
import { Helmet } from "react-helmet";

const products = [
  {
    id: 1,
    name: 'Ορός Προσώπου Πολυτελείας',
    shortDescription: 'Αντιγηραντικός ορός με φυσικά συστατικά',
    description: 'Ο πολυτελής ορός προσώπου μας περιέχει σπάνια φυτικά εκχυλίσματα που ανανεώνουν και αναζωογονούν το δέρμα σας. Κατάλληλος για όλους τους τύπους δέρματος.',
    price: 89.99,
    image: '/images/1.jpg',
    features: [
      'Φυσικά και βιολογικά συστατικά',
      'Κατάλληλο για όλους τους τύπους δέρματος',
      'Αντιγηραντικές ιδιότητες',
      'Βαθιά ενυδάτωση',
      'Χωρίς παραβένες και χημικά'
    ]
  },
  {
    id: 2,
    name: 'Κρέμα Νυχτός Premium',
    shortDescription: 'Εντατική αναδόμηση κατά τη διάρκεια του ύπνου',
    description: 'Η κρέμα νυχτός premium εργάζεται ενώ κοιμάστε για να σας χαρίσει λαμπερό και αναζωογονημένο δέρμα κάθε πρωί. Εμπλουτισμένη με βιταμίνες και αντιοξειδωτικά.',
    price: 75.50,
    image: '/images/2.jpg',
    features: [
      'Εντατική αναδόμηση νυχτερινή',
      'Βιταμίνες A, C, E',
      'Αντιοξειδωτική προστασία',
      'Μειώνει τις ρυτίδες',
      'Απαλή και μεταξένια υφή'
    ]
  },
  {
    id: 3,
    name: 'Μάσκα Ομορφιάς Χρυσού',
    shortDescription: 'Μάσκα με 24K χρυσό για άμεση λάμψη',
    description: 'Η μοναδική μας μάσκα ομορφιάς εμπλουτισμένη με 24K χρυσό προσφέρει άμεση λάμψη και σύσφιξη. Ιδανική για ειδικές περιστάσεις ή εβδομαδιαία περιποίηση.',
    price: 125.00,
    image: '/images/3.jpg',
    features: [
      'Περιέχει 24K χρυσό',
      'Άμεση λάμψη και lifting',
      'Σύσφιξη και τόνωση',
      'Πλούσια σε κολλαγόνο',
      'Αποτελέσματα από την πρώτη χρήση'
    ]
  },
  {
    id: 4,
    name: 'Ελιξίριο Ματιών',
    shortDescription: 'Εξαλείφει μαύρους κύκλους και οίδημα',
    description: 'Το εξειδικευμένο ελιξίριο για την περιοχή των ματιών μειώνει την κούραση, τους μαύρους κύκλους και το οίδημα. Απαλή φόρμουλα για ευαίσθητο δέρμα.',
    price: 65.00,
    image: '/images/4.jpg',
    features: [
      'Μειώνει μαύρους κύκλους',
      'Αποσυμφορεί το οίδημα',
      'Ενυδατώνει την ευαίσθητη περιοχή',
      'Αντιγηραντική δράση',
      'Ελαφριά υφή που απορροφάται γρήγορα'
    ]
  },
  {
    id: 5,
    name: 'Πακέτο Περιποίησης Deluxe',
    shortDescription: 'Πλήρης ρουτίνα περιποίησης πολυτελείας',
    description: 'Το πλήρες σετ περιποίησης που περιλαμβάνει όλα τα απαραίτητα προϊόντα για μια ολοκληρωμένη ρουτίνα ομορφιάς. Ιδανικό για δώρο ή για να ξεκινήσετε το ταξίδι σας προς την τέλεια επιδερμίδα.',
    price: 299.99,
    image: '/images/5.jpg',
    features: [
      'Πλήρες σετ περιποίησης',
      'Όλα τα απαραίτητα προϊόντα',
      'Οικονομική πρόταση',
      'Πολυτελής συσκευασία δώρου',
      'Οδηγίες χρήσης step-by-step'
    ]
  }
];

function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [quantity, setQuantity] = useState(1);

  const product = products.find(p => p.id === parseInt(id));

  if (!product) {
    return (
      <div className="product-detail-container">
        <h1>Το προϊόν δεν βρέθηκε</h1>
        <button onClick={() => navigate('/')} className="btn btn-primary">
          Επιστροφή στην Αρχική
        </button>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product, quantity);
  };

  const handleBuyNow = () => {
    addToCart(product, quantity);
    navigate('/checkout');
  };

  const increaseQuantity = () => {
    setQuantity(prev => prev + 1);
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(prev => prev - 1);
    }
  };

  return (
    <>
      <Helmet>
        <title>Sororin - Κατάστημα Ομορφιάς</title>
        <meta name="description" content="Sororin - Κατάστημα Ομορφιάς με προϊόντα υψηλής ποιότητας. Ανακαλύψτε την πολυτελή συλλογή μας από προϊόντα περιποίησης και ομορφιάς." />
      </Helmet>

      <div className="product-detail-container">
      <div className="product-detail-grid">
        <div className="product-detail-image-wrapper">
          <img src={product.image} alt={product.name} className="product-detail-image" />
        </div>

        <div className="product-detail-info">
          <h1>{product.name}</h1>
          
          <div className="product-rating">
            <div className="stars">
              {[1, 2, 3, 4, 5].map(star => (
                <FaStar key={star} className="star-icon" />
              ))}
            </div>
            <span className="rating-text">(5.0) - Εξαιρετικό</span>
          </div>

          <p className="product-detail-description">{product.description}</p>

          <p className="product-detail-price">€{product.price.toFixed(2)}</p>

          <div className="quantity-selector">
            <label>Ποσότητα:</label>
            <div className="quantity-controls">
              <button onClick={decreaseQuantity} className="quantity-btn">-</button>
              <span className="quantity-display">{quantity}</span>
              <button onClick={increaseQuantity} className="quantity-btn">+</button>
            </div>
          </div>

          <div className="product-actions">
            <button onClick={handleAddToCart} className="btn btn-secondary">
              <FaShoppingCart /> Προσθήκη στο Καλάθι
            </button>
            <button onClick={handleBuyNow} className="btn btn-primary">
              Αγορά Τώρα
            </button>
          </div>
        </div>
      </div>

      <div className="product-features">
        <h2>Χαρακτηριστικά Προϊόντος</h2>
        <ul className="features-list">
          {product.features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      </div>

      <section className="detailed-info-section" style={{ marginTop: '3rem' }}>
        <h2>Περισσότερες Πληροφορίες</h2>
        <div className="info-content">
          <p className="info-paragraph">
            Το {product.name} είναι αποτέλεσμα χρόνων έρευνας και ανάπτυξης από την ομάδα 
            ειδικών μας. Κάθε συστατικό επιλέγεται προσεκτικά για την αποτελεσματικότητα 
            και την ασφάλειά του. Η φόρμουλά μας είναι δερματολογικά δοκιμασμένη και 
            κατάλληλη για όλους τους τύπους δέρματος.
          </p>
          <p className="info-paragraph">
            Παράγεται στην Ελλάδα με αυστηρά πρότυπα ποιότητας και σεβασμό στο περιβάλλον. 
            Η συσκευασία μας είναι ανακυκλώσιμη και φιλική προς το περιβάλλον. Δεσμευόμαστε 
            για την βιωσιμότητα και την κοινωνική ευθύνη σε κάθε στάδιο της παραγωγής.
          </p>
          <p className="info-paragraph">
            Για βέλτιστα αποτελέσματα, συνιστούμε να χρησιμοποιείτε το προϊόν καθημερινά 
            ως μέρος της ρουτίνας περιποίησής σας. Τα αποτελέσματα είναι ορατά εντός λίγων 
            εβδομάδων με συνεχή χρήση. Σε περίπτωση ερωτήσεων, η ομάδα μας είναι πάντα 
            διαθέσιμη να σας βοηθήσει.
          </p>
        </div>
      </section>
    </div>
  
    </>);
}

export default ProductDetail;